import { render, staticRenderFns } from "./SortOrFilter.vue?vue&type=template&id=137a387e&scoped=true&"
import script from "./SortOrFilter.vue?vue&type=script&lang=js&"
export * from "./SortOrFilter.vue?vue&type=script&lang=js&"
import style0 from "./SortOrFilter.vue?vue&type=style&index=0&id=137a387e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137a387e",
  null
  
)

export default component.exports